import { FormGroup, Label, Select } from "@components";
import { UpdatedModuleSetting, NewModuleSetting } from "@models";
import { PublicTransportTaxVariant } from "@models/products/ProductMobility";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { ConfigModuleSetting } from "./types";

type Props = {
	moduleSetting: UpdatedModuleSetting | NewModuleSetting;
};
export default function ModuleSettingMobilitySettings(props: Props) {
	const { control } = useFormContext<ConfigModuleSetting>();
	return (
		<FormGroup as={Row}>
			<Label column sm={4} htmlFor="publicTransport">
				ÖPNV-Versteuerung
			</Label>
			<Col sm={8}>
				<Controller
					name={"settings.publicTransportTaxVariant" as any}
					control={control}
					defaultValue={props.moduleSetting.settings?.publicTransportTaxVariant}
					render={({ field }) => (
						<Select
							disabled
							id="publicTransport"
							{...field}
							value={field.value ?? ""}
						>
							<option value=""></option>
							<option value={PublicTransportTaxVariant.Taxfree}>
								Steuerfrei
							</option>
							<option value={PublicTransportTaxVariant.Tax25}>
								25% pauschalversteuert
							</option>
						</Select>
					)}
				/>
			</Col>
		</FormGroup>
	);
}
